<template>
  <div class="PackView">
    <el-dialog title="物品说明"
               :visible.sync="goodsInfoShow"
               width="500px">
      <el-table :data="wptype"
                style="width: 100%"
                border>
        <el-table-column prop="name"
                         label="物品名"
                         width="180">
        </el-table-column>
        <el-table-column prop="info"
                         label="物品说明">
        </el-table-column>
      </el-table>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="goodsInfoShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="goodsInfoShow = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="isShowChangeGoods"
               width="40%"
               v-if="changeGoods!==-1">
      <div class="wpinfo_list">
        <div @change="handleChange"
             v-for="(item, index) in allData_copy"
             :key="item.id">
          <div :title="item.name"
               :name="index"
               v-if="changeGoods==index">
            <el-tag>
              <span>物品ID : </span>
              <span class="el-tag_text">
                {{ item.id }}
              </span>
            </el-tag>

            <el-tag>
              <span>中文名 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.name"> </el-input>
              </span>
            </el-tag>

            <el-tag>
              <span>英文名 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.enname"> </el-input>
              </span>
            </el-tag>

            <el-tag>
              <span>单价 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.unitprice">
                </el-input>
              </span>
            </el-tag>

            <el-tag>
              <span>物品数量 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.num"> </el-input>
              </span>
            </el-tag>

            <el-tag class="select_cls">
              <span>数量单位 : </span>
              <span class="el-tag_text">
                <el-select v-model="item.unit"
                           placeholder="空">
                  <el-option v-for="(item, index) in unitData"
                             :key="index"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </span>
            </el-tag>

            <el-tag>
              <span>总价 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.totalamoun">
                </el-input>
              </span>
            </el-tag>

            <el-tag class="select_cls">
              <span>货币类型 : </span>
              <span class="el-tag_text">
                <el-select v-model="item.currencty"
                           placeholder="空">
                  <el-option v-for="(item, index) in currencty"
                             :key="index"
                             :label="index"
                             :value="item">
                  </el-option>
                </el-select>
              </span>
            </el-tag>

            <el-tag class="select_cls"
                    :class="item.wptype==0?'danger':''"
                    :type="item.wptype==0?'danger':''">
              <span>类型 : </span>
              <span class="el-tag_text">
                <el-select v-model="item.wptype"
                           placeholder="空">

                  <el-option v-for="item in wptype"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>

                </el-select>
              </span>
            </el-tag>
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="isShowChangeGoods = false">取 消</el-button>
        <el-button type="primary"
                   @click="ConfirmSubmit(true)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示"
               :visible.sync="alterWpinfo_show"
               width="40%">
      <div class="wpinfo_list">
        <el-collapse @change="handleChange">
          <el-collapse-item :title="item.name"
                            v-for="(item, index) in allData_copy"
                            :key="item.id"
                            :name="index">
            <el-tag>
              <span>物品ID : </span>
              <span class="el-tag_text">
                {{ item.id }}
              </span>
            </el-tag>

            <el-tag>
              <span>中文名 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.name"> </el-input>
              </span>
            </el-tag>

            <el-tag>
              <span>英文名 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.enname"> </el-input>
              </span>
            </el-tag>

            <el-tag>
              <span>单价 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.unitprice">
                </el-input>
              </span>
            </el-tag>

            <el-tag>
              <span>物品数量 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.num"> </el-input>
              </span>
            </el-tag>

            <el-tag class="select_cls">
              <span>数量单位 : </span>
              <span class="el-tag_text">
                <el-select v-model="item.unit"
                           placeholder="空">
                  <el-option v-for="(item, index) in unitData"
                             :key="index"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </span>
            </el-tag>

            <el-tag>
              <span>总价 : </span>
              <span class="el-tag_text">
                <el-input size="mini"
                          placeholder="空"
                          v-model="item.totalamoun">
                </el-input>
              </span>
            </el-tag>

            <el-tag class="select_cls">
              <span>货币类型 : </span>
              <span class="el-tag_text">
                <el-select v-model="item.currencty"
                           placeholder="空">
                  <el-option v-for="(item, index) in currencty"
                             :key="index"
                             :label="index"
                             :value="item">
                  </el-option>
                </el-select>
              </span>
            </el-tag>

            <el-tag class="select_cls"
                    :class="item.wptype==0?'danger':''"
                    :type="item.wptype==0?'danger':''">
              <span>类型 : </span>
              <span class="el-tag_text">
                <el-select v-model="item.wptype"
                           placeholder="空">

                  <el-option v-for="item in wptype"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>

                </el-select>
              </span>
            </el-tag>
          </el-collapse-item>
        </el-collapse>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="alterWpinfo_show = false">取 消</el-button>
        <el-button type="primary"
                   @click="ConfirmSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="请添加附加费"
               :visible.sync="additionalShow"
               width="500px">
      <el-form>

        <el-form-item label="附加费信息:"
                      label-position='top'>
          <div class="item_view">
            <div class="view_list">
              <span>名称:</span>
              <el-select v-model="additionalInfo"
                         placeholder="显示出的名称">
                <el-option label="超长附加费"
                           value="超长附加费">
                </el-option>
                <el-option label="超重附加费"
                           value="超重附加费">
                </el-option>
              </el-select>

            </div>
            <div class="view_list">
              <span>金额:</span>
              <el-input v-model.number="additionalPrice"
                        type="number"
                        placeholder='附加费金额（RMB）'></el-input>
            </div>

          </div>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="additionalShow = false">取 消</el-button>
        <el-button type="primary"
                   @click="addAdditional()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="其他操作"
               :visible.sync="otherOperation"
               width="400px">
      <div class="other_view">
        <el-button type="primary"
                   @click="additionalShow=true">添加附加费</el-button>
        <el-button type="primary"
                   @click="skipOrderInvoice">打印票单</el-button>
        <el-button type="primary"
                   @click="returnPage()">返回页面</el-button>
      </div>
    </el-dialog>
    <div class="PackView_top">
      <el-button type="primary"
                 @click="alterWpinfo()"
                 plain>
        查看/修改物品信息
      </el-button>
      <el-button type="primary"
                 @click="goodsInfoShow=true"
                 plain>
        查看物品说明
      </el-button>
    </div>
    <div class="PackView_main">
      <!-- ---------------------------------------------------- -->

      <div class="PackView_transfer"
           v-for="(item, index_1) in bgData"
           :key="index_1">
        <el-divider>包裹{{ index_1 + 1 }}</el-divider>

        <div class="PackView_transfer_top">
          <el-form :model="bgData[index_1].zxdInfo"
                   :ref="'numberValidateForm' + index_1"
                   label-width="100px">
            <el-form-item label="长度(cm)"
                          prop="chang"
                          :rules="[
                { required: true, message: '长度不能为空' },
                { type: 'number', message: '长度必须为数字值' },
              ]">
              <el-input type="number"
                        v-model.number="bgData[index_1].zxdInfo.chang"
                        autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="宽度(cm)"
                          prop="kuan"
                          :rules="[
                { required: true, message: '宽度不能为空' },
                { type: 'number', message: '宽度必须为数字值' },
              ]">
              <el-input type="number"
                        v-model.number="bgData[index_1].zxdInfo.kuan"
                        autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="高度(cm)"
                          :rules="[
                { required: true, message: '高度不能为空' },
                { type: 'number', message: '高度必须为数字值' },
              ]"
                          prop="gao">
              <el-input type="number"
                        v-model.number="bgData[index_1].zxdInfo.gao"
                        autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="重量(kg)"
                          prop="weight"
                          :rules="[
                { required: true, message: '重量不能为空' },
                { type: 'number', message: '重量必须为数字值' },
              ]">
              <el-input type="number"
                        v-model.number="bgData[index_1].zxdInfo.weight"
                        autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item v-if="bgData.length>1">

              <el-button type="danger"
                         @click="removerBox(index_1)"><i class="el-icon-delete"></i></el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-transfer v-model="bgData[index_1].wpinfo"
                     :data="allData"
                     :props="{
      key: 'index',
      label: 'name'
    }"
                     :titles="['待打包物品','箱号'+parseInt(index_1+1,10) ]"
                     :button-texts="['拿出', '放入']">
          <span slot-scope="{ option }">
            <span :class="option.wptype ==0?'danger_item':''"
                  @click="popupDebugging(option)">{{ option.name}} -{{option.kdnum}}</span>
          </span>
        </el-transfer>

      </div>
      <!-- ---------------------------------------------------- -->

      <!-- --------------------------------------- -->
    </div>
    <div class="PackView_bottom">
      <div class="PackView_transfer_add">
        <el-button type="success"
                   @click="addParcel('numberValidateForm' + active_num)"
                   plain>
          增 加 箱 号
        </el-button>
      </div>
      <el-button type="primary"
                 size="medium"
                 @click="submitPack">提 交 打 包</el-button>
    </div>
  </div>
</template>

<script>
import common from '@/assets/js/common';
import { aptPackinfo, apiAppAdditional } from "@/request/api";
export default {
  name: "PackView",
  data () {
    return {
      // ------------是否显示物品说明------------
      goodsInfoShow: false,
      // -------------是否显示更改某一个物品-----------
      isShowChangeGoods: false,
      // -------------修改物品的索引-----------
      changeGoods: -1,
      // -------------获取订单id-----------
      orderId: '',
      // -------------推荐附加费-名称-----------
      additionalInfo: '',
      // -------------推荐附加费-金额-----------
      additionalPrice: '',
      // -------------仓库添加附加费-----------
      additionalShow: false,
      //------------------其他操作---------------------
      otherOperation: false,
      //---------------------------------------
      dataAll: [],
      //---------------------------------------
      active_num: 0,
      wptype: [],
      unitData: ["个", "台", "套", "双", "件", "只", "支", "把", "本", "片", "条"],

      currencty: {
        人民币: "CNY",
        美元: "USD",
        越南盾: "VND",
        新加坡元: "MOP",
        日元: "JPY",
        韩元: "KRW",
        马币: "MYR",
        台币: "NTD",
        港币: "HKD",
        欧元: "EUR",
        英镑: "GBP",
        法郎: "FRF",
        印度卢比: "INR",
        俄罗斯卢布: "RUB",
        澳大利亚元: "AUD",
        荷兰盾: "NLG",
      },

      allData_copy: "",
      allData: [

      ],
      bgData: [
        {
          invoking: {
            checkedCities: [],
            selected_num: 0,
            isIndeterminate: false,
            checkAll: false,
          },
          parameter: {
            isIndeterminate: false,
            checkAll: false,
            checkedCities: [],
            selected_num: 0,
            dataAll: [],
          },
          wpinfo: [],
          zxdInfo: {
            chang: "",
            kuan: "",
            gao: "",
            weight: "",
          },
        },
      ],
      alterWpinfo_show: false,
    };
  },
  methods: {
    // -------------删除箱-----------
    removerBox (index) {
      this.$confirm('将删除此箱号, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.bgData.splice(index, 1)

        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // -------------弹出调试框-----------
    popupDebugging (e) {
      if (!this.allData_copy[e.index].wptype) {
        this.changeGoods = e.index
        this.isShowChangeGoods = true
      } else {

      }
    },
    // -------------返回上一页-----------
    returnPage () {
      this.$router.go(-1)
    },
    // -------------跳转打印票单-----------
    skipOrderInvoice () {
      this.$router.replace({
        name: 'Invoice',
        query: {
          id: this.$route.query.id,
        }
      })
    },
    // -------------添加附加费-----------
    async addAdditional () {
      let res = await apiAppAdditional({
        op: 'otherprice',
        // wlnum: this.additionalWlnum,
        orderid: this.orderid,
        pd: 'ok',
        otherprice: this.additionalPrice,
        otherpriceinfo: this.additionalInfo
      })
      if (res.errno == 1) {
        return this.$message.error(res.message)
      } else {
        this.$message.success(res.message)
        this.additionalPrice = '';
        this.additionalInfo = '';
      }
      this.additionalShow = false
    },
    //-------获取物品信息-------
    async getPackinfo (id) {
      let res = await aptPackinfo({
        orderid: id,
        pd: "getinfo",
      });
      if (res.errno == 0) {
        this.wptype = common.transform(res.wptype);
        this.orderid = res.orderinfo.id
        this.allData = [];
        for (const k in res.orderinfo.zxdinfo) {
          for (const key in res.orderinfo.zxdinfo[k]) {
            for (const ke in res.orderinfo.zxdinfo[k][key].wpinfo) {
              res.orderinfo.zxdinfo[k][key].wpinfo[ke].index = this.allData.length
              res.orderinfo.zxdinfo[k][key].wpinfo[ke].kdnum = k
              res.orderinfo.zxdinfo[k][key].wpinfo[ke].wptype = -1
              this.allData.push(res.orderinfo.zxdinfo[k][key].wpinfo[ke]);
            }
          }
        }
        this.allData_copy = JSON.parse(JSON.stringify(this.allData));
        for (const k in this.allData) {
          this.dataAll.push(this.allData[k].id);
        }
      } else {
      }
    },

    //-------修改物品信息-------
    alterWpinfo () {
      this.alterWpinfo_show = true;
    },

    //-------激活折叠栏回调函数-------
    handleChange (val) {
    },

    //-------添加包裹-------
    addParcel (formName) {
      this.$confirm("是否添加一个包裹, 请确定已经填写好装箱单信息", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.active_num++;
          this.bgData.push({
            wpinfo: [],
            zxdInfo: {
              chang: "",
              kuan: "",
              gao: "",
              weight: "",
            },
            invoking: {
              checkedCities: [],
              selected_num: 0,
            },
            parameter: {
              isIndeterminate: false,
              checkAll: false,
              checkedCities: [],
              dataAll: [],
              selected_num: 0,
            },
          });
          this.$message({
            type: "success",
            message: "添加成功!",
          });

        })
        .catch(() => { });
    },

    //-------添加或者删除物品-------
    addRemoveGoods (index) {
      let formData = this.bgData[index].invoking.checkedCities;
      //循环用户选中的物品
      for (const key in formData) {
        //循环所有物品
        for (const k in this.allData) {
          //如果用户选中的物品ID和所有物品的某一个ID相同就拿出物品
          if (formData[key] == this.allData[k].id) {
            // 拿出物品打包到新包裹
            this.bgData[index].wpinfo.push.apply(
              this.bgData[index].wpinfo,
              this.allData.splice(k, 1)
            );

          }

        }
      }
      for (const key in this.bgData[index].wpinfo) {
        this.bgData[index].parameter.dataAll.push(this.bgData[index].wpinfo[key].id);
      }
      this.bgData[index].invoking.selected_num = 0;
      this.bgData[index].invoking.isIndeterminate = false;
      this.bgData[index].invoking.checkedCities = [];
      this.bgData[index].invoking.checkAll = false;
    },






    //-------确认提交修改物品信息-------
    ConfirmSubmit (falg) {
      this.$confirm(
        "确定修改物品信息吗,该修改只用于提交使用,刷新页面会还原数据",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        if (falg) {
          this.isShowChangeGoods = false

        } else {
          this.alterWpinfo_show = false

        }
        this.$nextTick(() => {
          this.$set(this, 'allData', this.allData_copy)
        })
        // this.allData = this.allData_copy;
        this.$message({
          type: "success",
          message: "修改成功!",
        });
      });
    },

    //-------提交打包-------
    submitPack () {
      this.$confirm("确定提交数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.datafull()) {
            this.setPackinfoData(this.detectionData())
          }
        })
        .catch(() => { });
    },

    //-------数据处理-------
    detectionData () {
      let submitData = {
        pd: 'okdabao',
        orderid: this.$route.query.id,
        zxdinfo: []
      }
      let resData = JSON.parse(JSON.stringify(this.allData))
      for (const key in this.bgData) {
        let wpinfo = []
        for (const k in this.bgData[key].wpinfo) {
          delete resData[this.bgData[key].wpinfo[k]].id
          wpinfo.push(resData[this.bgData[key].wpinfo[k]])
        }
        submitData.zxdinfo.push({
          no: parseInt(key) + 1,
          chang: this.bgData[key].zxdInfo.chang,
          kuan: this.bgData[key].zxdInfo.kuan,
          gao: this.bgData[key].zxdInfo.gao,
          weight: this.bgData[key].zxdInfo.weight,
          wpinfo: wpinfo
        })
      }
      submitData.zxdinfo = JSON.stringify(submitData.zxdinfo)
      return submitData
    },

    //-------发起打包请求-------
    async setPackinfoData (data) {
      let res = await aptPackinfo(data)
      if (res.errno == 0) {
        this.$message.success('打包成功,请选择其他操作')
        this.otherOperation = true
      } else {
        this.$message.error(res.message)

      }
    },

    //-------数据检查是否完整-------
    datafull () {
      let falg = true
      let allLength = 0

      for (const key in this.bgData) {
        allLength += this.bgData[key].wpinfo.length
      }
      if (allLength >= this.allData.length) {
        for (const key in this.bgData) {
          for (const k in this.bgData[key].zxdInfo) {
            if (this.bgData[key].zxdInfo[k] === '') {
              this.$message.error('错误,请检查第' + (parseInt(key) + 1) + '箱的装箱单信息')
              return false
            }
          }
        }
      } else {
        this.$message.error('错误,请将所有物品全部打包')
        return false
      }
      return falg
    }
  },

  created () {
    this.getPackinfo(this.$route.query.id);
  },
};
</script>

<style lang="scss">
.danger_item {
  width: 100%;
  display: block;
  color: #f56c6c !important;
}
.ta-transfer {
  height: 400px;
  width: 900px;
  margin-bottom: 50px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ta-transfer_left,
  .ta-transfer_right {
    width: 30%;
    height: 100%;
    background-color: #ffffff;
    border: 1px solid #ebeef5;
    border-radius: 5px;
    .transfer-view-head {
      width: 100%;
      height: 50px;
      background-color: #f5f7fa;
      border-bottom: 1px solid #ebeef5;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
      .head_left {
        display: flex;
        width: 100%;
        height: 100%;

        .el-checkbox {
          display: flex;
          align-items: center;
          height: 100%;
          width: 100%;
        }
        .el-checkbox__label {
          font-size: 16px;
        }
      }
      .head_right {
        span {
          font-size: 14px;
          color: #909399;
        }
      }
    }
    .transfer-view-main {
      width: 100%;
      height: 100%;
      padding: 10px 10px 0 10px;
      box-sizing: border-box;
      overflow-y: auto;

      .transfer-view-item {
        margin-bottom: 10px;
        width: 100%;
        height: 20px;
        // background-color: #c5c1c1;
        display: flex;
        align-items: center;
        .el-checkbox {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
          .el-checkbox__label {
            color: #606266;
          }
          .el-checkbox__input.is-checked + .el-checkbox__label {
            color: #409eff;
          }
        }
        .el-checkbox:hover {
          .el-checkbox__label {
            color: #409eff;
          }
        }
      }
    }
  }
  .ta-transfer_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 100px;
  }
}
.PackView {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  .item_view {
    display: flex;
    margin-top: 40px;
    justify-content: space-between;
    .view_list {
      display: flex;
      width: 45%;
      span {
        width: 50px;
      }
    }
  }
  .other_view {
    display: flex;
    justify-content: center;
  }
  .wpinfo_list {
    .select_cls {
      .el-input__inner {
        height: 30px;
      }
      .el-input {
        max-width: 60px !important ;
        border: 0;
      }
    }
    .danger {
      .el-input input {
        color: #f56c6c !important;
      }
    }
    .el-tag {
      font-size: 14px;
      margin-right: 10px;
      margin-bottom: 10px;
      transition: all 0.3s;
      .el-tag_text {
        // font-weight: 700;
        // justify-content: center;
        .el-input__suffix {
          display: none;
        }
        .el-input {
          max-width: 30px;
          border: 0;
          input {
            padding: 0;
            border: 0;
            font-size: 14px;
            background-color: transparent;
            color: #409eff;
            transition: all 0.3s;
          }
        }
      }
    }
  }
  .PackView_top {
    width: 100%;
    min-height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .PackView_bottom {
    width: 100%;
    height: 60px;
    box-sizing: border-box;
    padding: 0 10%;
    background-color: #f5f7fa;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .PackView_transfer_add {
      margin-right: 10px;
    }
    .el-button {
      width: 120px;
      height: 40px;
      border-radius: 10px;
    }
  }
  .PackView_main {
    box-shadow: 0 0 5px 1px #f5f7fa;
    width: 100%;
    height: 70%;
    padding-bottom: 100px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    overflow-y: auto;
    .PackView_transfer_add {
      width: 900px;
      height: 100px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .PackView_transfer {
      height: 600px;
      width: 900px;
      padding-bottom: 50px;
      margin-bottom: 50px;
      // background-color: pink;
      // background-color: pink;
      .el-transfer {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .PackView_transfer_top {
        width: 100%;
        // height: 180px;
        margin-bottom: 20px;
        background-color: #f5f7fa;
        border: 1px solid #ebeef5;
        .el-form {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          padding-top: 10px;
          box-sizing: border-box;
          .el-form-item {
            width: 30%;
          }
        }
      }
    }
  }
}
</style>
